import { gql, useMutation } from '@apollo/client';

const UPDATE_CART = gql`
  mutation UpdateCartItem($keyId: Uuid!, $status:Text!) {
    v2UpdateCartById(
      postCheck: {}
      keyId: $keyId
      updateColumns: {status: {set: $status}}
    ) {
      affectedRows
    }
  }
`

const useUpdateCart = () => {
  const [updateCart, { data, loading, error }] = useMutation(UPDATE_CART, {
    context: {
      headers: {
        "x-hasura-role": "learner",
      },
    },
  });

  return { updateCart, data, loading, error };
}

export default useUpdateCart;